import React from 'react';
import {withSnackbar} from "notistack";
import "./Modal.css"
import {
    Modal,
} from 'react-bootstrap';
import ModalForgotPassword2 from "./modalForgotPassword2";
import Authentication from "../../../services/auth";
import UserController from "../../../services/system/user/user-controller";

class ModalChangePassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            code: '000000',
            oldPassword: '',
            newpassword: '',
            repassword: '',
            signupInfo: null,
            errNewPass: false,
            errRePass: false,
        };
    }

    componentDidMount() {
        this.setState({
            code: '000000',
            oldPassword: '',
            newpassword: '',
            repassword: '',
            errNewPass: false,
            errRePass: false,
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.show) {
            this.setState({
                code: '000000',
                newpassword: '',
                oldPassword: '',
                repassword: '',
                errNewPass: false,
                errRePass: false,
            });
        }
    }

    onSubmit = () => {
        if (this.state.newpassword.length < 6) {
            this.setState({
                errNewPass: true,
            })
            this.props.enqueueSnackbar('Mật khẩu không được nhỏ hơn 6 kí tự !', {
                variant: 'error',
            });
        } else if (this.state.repassword.length < 6) {
            this.setState({
                errRePass: true,
            })
            this.props.enqueueSnackbar('Mật khẩu không được nhỏ hơn 6 kí tự !', {
                variant: 'error',
            });
        } else if (this.state.newpassword != this.state.repassword) {
            this.setState({
                errRePass: true,
            })
            this.props.enqueueSnackbar('Nhập lại mật khẩu chưa chính xác !', {
                variant: 'error',
            });
        } else {
            this.changePassword()
        }
    }

    changePassword = () => {
        let payload = {
            code: this.state.code,
            oldPassword: this.state.oldPassword,
            newPassword: this.state.newpassword
        }
        UserController.changePassword(payload, res => {
            if (res.success) {
                this.props.enqueueSnackbar('Thay đổi mật khẩu thành công !', {
                    variant: 'success',
                });
                this.props.onHideModal();
            } else {
                this.props.enqueueSnackbar(res.message[0], {
                    variant: 'error',
                });
            }
        })
    }


    render() {
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHideModal,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered">
                    <div className="btn-close">
                        <button type="button" className="close" onClick={this.props.onHideModal}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-container">

                    </div>
                    <Modal.Body>

                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>ĐỔI MẬT KHẨU</b></h1>
                        </div>

                        <div>
                            <div className="row">
                                <label className="col-5 mt-2">Mật khẩu cũ </label>
                                <input
                                    type="text"
                                    className="inputPassword w-100 col-7"
                                    placeholder="Nhập mật khẩu cũ"
                                    maxLength={20}
                                    value={this.state.oldPassword}
                                    onChange={(e) => this.setState({
                                        oldPassword: e.target.value.trim()
                                        }
                                    )}
                                />
                            </div>

                            <div className="row mt-3">
                                <label className="col-5 mt-2">Mật khẩu mới: </label>
                                <input
                                    type="password"
                                    className={this.state.errNewPass ? "inputPassword w-100 col-7 border-input-error " : "inputPassword w-100 col-7 "}
                                    placeholder="Nhập mật khẩu mới"
                                    fullWidth
                                    maxLength={20}
                                    value={this.state.newpassword}
                                    onChange={(e) => this.setState({
                                            newpassword: e.target.value.trim(),
                                            errNewPass: false
                                        },
                                        () => {
                                            this.state.newpassword.length == 0 ? this.setState({errNewPass: true}) : this.setState({errNewPass: false})
                                        }
                                    )}
                                />
                            </div>

                            <div className="row mt-3">
                                <label className="col-5 mt-2">Nhập lại mật khẩu: </label>
                                <input
                                    type="password"
                                    className={this.state.errRePass ? "inputPassword w-100 col-7 border-input-error" : "inputPassword w-100 col-7 "}
                                    placeholder='Xác nhận mật khẩu mới'
                                    fullWidth
                                    maxLength={20}
                                    value={this.state.repassword}
                                    onChange={(e) => this.setState({
                                            repassword: e.target.value.trim(),
                                            errRePass: false
                                        },
                                        () => {
                                            this.state.repassword.length == 0 ? this.setState({errRePass: true}) : this.setState({errRePass: false})
                                        }
                                    )}
                                />
                            </div>
                        </div>

                        <div container item xs={12}>
                            <div item xs={12}>
                                <div className="align-center mt-3 mb-2">
                                    <button
                                        // type="button"
                                        className={this.state.newpassword?.length == 0 || this.state.repassword?.length == 0 ? "btn btn-secondary w-50 type-button-fix" : "btn btn-primary w-50 type-button-fix"}
                                        disabled={this.state.newpassword?.length == 0 || this.state.repassword?.length == 0}
                                        onClick={this.onSubmit}
                                    >
                                          <span>
                                            Xác nhận
                                            <i className="flaticon-right"/>
                                          </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
                <ModalForgotPassword2 show={this.state.showForgotPassword2}
                                      onHideModal={this.onCloseModalForgotPassword2} otp={this.state.otpCode}
                                      token={this.props.token}/>
            </div>
        );
    }
}


export default withSnackbar(ModalChangePassword);
